import Vue from 'vue';
import Router from 'vue-router';
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import utils from '@/jslibs/utils' // getToken from cookie


NProgress.configure({
	showSpinner: false
}) // NProgress Configuration

import userManage from './modules/user/list';
import feedbackManage from './modules/user/feedback';
import deviceManage from './modules/device/list';
import noticeManage from './modules/device/notice';
import utilManage from './modules/device/util';
import importManage from './modules/device/import';
import firmwareManage from './modules/firmware/list';
import AdminManage from './modules/permission/admin';
import RoleManage from './modules/permission/role';
import MenuManage from './modules/permission/menu';
import LogManage from './modules/permission/log';
import messageManage from './modules/message/list';
import statisticsDevice from './modules/statistics/device';
import statisticsCommunity from './modules/statistics/community';
import statisticsUser from './modules/statistics/user';
import vestManage from './modules/community/vest';
import hotManage from './modules/community/hot';
import topicManage from './modules/community/topic';
import commentManage from './modules/community/comment';
import recommendManage from './modules/community/recommend';
import postManage from './modules/community/post';
import auditManage from './modules/community/audit';
import tutorialManage from './modules/content/tutorial';
import appManage from './modules/content/app';
import manualManage from './modules/content/manual';
import questionManage from './modules/content/question';
import protocolManage from './modules/content/protocol';
const Login = () => import('@/pages/Login');
const Index = () => import('@/pages/Index');
Vue.use(Router);

const whiteList = ['/login'] // no redirect whitelist

var children = [
	// 新
	...userManage,
	...feedbackManage,
	...deviceManage,
	...noticeManage,
	...utilManage,
	...importManage,
	...firmwareManage,
	...AdminManage,
	...RoleManage,
	...MenuManage,
	...LogManage,
	...messageManage,
	...statisticsDevice,
	...statisticsCommunity,
	...statisticsUser,
	...vestManage,
	...hotManage,
	...topicManage,
	...commentManage,
	...recommendManage,
	...postManage,
	...auditManage,
	...tutorialManage,
	...appManage,
	...manualManage,
	...questionManage,
	...protocolManage
];

const router = new Router({
	routes: [{
		path: '',
		redirect: '/user/list'
	}, {
		path: '/login',
		component: Login
	}, {
		path: '/index',
		component: Index,
		children
	}]
	// mode: 'history',
});


router.beforeEach((to, from, next) => {
	children = [];
	NProgress.start()
	if (utils.getCookie("authorization")) {
		// 已登录且要跳转的页面是登录页
		if (to.path === '/login') {
			//console.log("login")
			next()
			NProgress.done()
		} else {
			next()
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
			NProgress.done()
		}
	}

})

router.afterEach(() => {
	NProgress.done() // finish progress bar
})

export default router;
